/**
 * 营运中心--》开单页
 */

export default {
  // 网络运单转托运单一进入页面是否要触发价格体系
  // 86637因为没触发，客户一直说偶尔价格体系算的不对，最后排查出原因是从网络订单页进来初始化带了数据，但是没触发价格体系，导致没算报关费和运费。
  trigger_acctrans_from_weborder: ['86637', '99259'], // 202506131742173371305
  // 开单是否启用收发货人的手机号支持筛选、电话支持筛选
  open_mobile_phone_grid_table: ['98259'], // 202506111100147509484
  // 自动收录接货车、接货司机, 开启后后端会自动收录，前端需要在开单完成后每次刷新
  auto_record_delivery_info: ['98628'], // 202506101649074074402
  // 上游来货，需要使用厂家单号来接收上游unit
  set_cjunit_from_up_unit: ['98380', '98377', '98378', '98379', '98381', '98382'], // 202506161132455032720
  // 客户价格体系如果匹配到送货费，能带出送货费。但是如果交接方式为自提，理论上要清空送货费。与产品沟通先定制
  clear_accsend_in_pickup: ['98259'], // 202506111742318001843

  /**
   * 涉及价格体系计算拦截的开关
   */
  // 普通改单场景下拦截触发基本运费价格体系
  no_calc_acctrans_in_normal_edit: ['97993', '78522'], // 202506261423524073673、202507231518031501387
  // 普通改单场景下拦截触发中转费价格体系
  no_calc_outaccC_in_normal_edit: ['97993'], // 202506050935421909341
  // 财务改单场景下拦截触发基本运费
  no_calc_acctrans_in_financial_edit: ['97993', '78522'], // 202506261423524073673、202507231518031501387
  // 财务改单场景下拦截触发中转费价格体系
  no_calc_outaccC_in_financial_edit: ['97993'], // 202506050935421909341

  // 开单是否拼单模式
  is_group_mode: ['98321', '98910', '98815'], // 202505291439416101893/202507281407314839448/202507281408042008356

  // 收货客户收录功能，增加收录时效字段
  auto_record_consignee_prescription: ['97276'], // 202506130817243803391
  // 收货客户收录功能，不收录门牌号
  no_record_dyh: ['97276'], // 202506130817243803391
  // 纯97276定制，修改开单页label
  // 门牌号名称改为“系统外地址” 备注改名为“备注1”，费用说明改名为“备注2”
  custom_label_in_97276: ['97276'], // 202506130817243803391
  // 纯97276定制，自定义计算计费重量、计费体积
  custom_calc_jf_w_v_97276: ['97276'], // 202506130817243803391
  // 纯90816定制，要根据体积和 装卸费单价相乘，来计算装卸费
  custom_calc_acczx_90816: ['90816'], // 202508191404454535433
  // 纯98161定制，根据运输方式来自定义计算计费重量
  custom_calc_jf_w_v_98161: ['98161'], // 202507041213537636658
  
  // 99171、83514 定制结算送货费价格体系 https://wiki.amh-group.com/pages/viewpage.action?pageId=1155734136
  custom_calc_accsend_c_83514: ['93514', '99171'], // 202510111747172409422
  // 开单保存是否记录匹配到的那一条运费价格体系维护的数据，本次97276定制，需要将匹配到的那一行的最低价和单价保存到服务端
  record_matched_acctrans_rule: ['97276'], // 202506130817243803391
  // 运费价格标准计算是否将匹配字段从重量改成计费重量、体积改成计费体积去算，本次97276定制
  calc_acctrans_use_jf_w_v: ['97276'], // 202506130817243803391
  // 如果价格是由运费价格体系匹配出来的，手动修改的运费低于标准价，不提示
  no_check_acctrans_below_bz: ['76955', '80831', '78633', '86578', '96188', '97276', '78522'], // 202506181309550736461
  // 重量体积校验模式，开放选项： 重量体积只第一行必填
  needwv_type_add_only_first_required: ['97993'], // 202506122347357176430

  // 基本运费、重量、体积 位数超过参数设置的位数时，截断模式是否是为舍弃模式，不要四舍五入。eg: 1.12349保留4位小数结果为1.1234，而不是1.1235
  // 调整前：https://imagecdn.ymm56.com/ymmfile/static/resource/ad6addcc-d49f-41e2-a0fd-97c2786392c7.png
  // 调整后：https://imagecdn.ymm56.com/ymmfile/static/resource/a16ea2b0-3ef4-479e-8c00-33940873bfb4.jpg
  acctrans_w_v_cut_in_round_down: ['97276'], // 202506301133012803694
  // 基本运费 位数超过参数设置的位数时，截断模式是否是为舍弃模式，不要四舍五入。eg: 1.12349保留4位小数结果为1.1234，而不是1.1235
  acctrans_cut_in_round_down: ['98651', '86617', '97267'], // 202509021034451172108 202509191635079539022 202510270939382738977

  // 发货人下拉选择，是否联动带出备注字段（开单场景）
  fill_remark_on_select_consignor: ['82635', '82914', '80834', '87835', '79603', '79605', '80831', '79602', '76955', '88569', '99810'], // 202507151139105978462，同时将之前的tmscode判断收归到此处

  // 收货人下拉选择，是否联动带出备注字段（开单场景）
  fill_remark_on_select_consignee: ['80834', '76955', '88854'], // 202512011934353706150 202408142127178635057  202410131541255436394
  // 重量超过三吨的不计算结算中转费202506251507181505880
  not_calculate_transport_fee_over_three_tons: ['97993'],
  // 开单收货人下来的选项要根据已选择的到站和发货人去联动做筛选, 本次新增，同时将之前的定制tmscode逻辑挪到这里
  // https://imagecdn.ymm56.com/ymmfile/static/resource/bce7461a-006e-491d-8a0a-31a249583892.png
  consignee_match_esite_parentid: ['76053', '78206', '81003', '86295', '86211', '86449', '88254', '89127', '89173', '83853', '96771', '88569'], // 202507151812463502785
  // 开启规格自定义，可以输入自定义规格
  open_custom_guige: ['98863'], // 202507111134594206067

  // 收货人区域开启 分机号字段
  show_consignee_ext_number: ['77577', '82635', '90252', '80819', '99153', '81919', '71091', '75766', '78996', '76792', '99120'], // 202508041016232937400
  // 如果发货人里面存在vip号，开单保存后则不自动收录发货人 https://imagecdn.ymm56.com/ymmfile/static/resource/276cdb67-04cb-4dea-8efa-c176b083691f.png
  no_store_vip_consignor: ['75501'], // 202507021133152609596
  // 目的站排序，先排一级，后排中转，一级网点需要按拼音排序
  // 公版逻辑: https://imagecdn.ymm56.com/ymmfile/static/resource/7d2c3ad5-b1c9-4f2b-b728-745408bcc7f3.jpg
  // 调整后: https://imagecdn.ymm56.com/ymmfile/static/resource/6bcd447c-772c-4ad5-ac8a-fe9f3e1b4683.jpg
  esite_sort_in_middle_site_end: ['85701'], // 202507241613340638962

  // 交接方式字段是否参与客户价格体系匹配条件，公版逻辑中交接方式变动是不参与的，本次定制为开关
  deliverytype_match_price: ['98161'], // 202508141054357905752
  // 客户价格体系，是否使用计费重量字段替代重量字段，来匹配价格体系命中逻辑
  calc_customer_acctrans_use_jf_w: ['98161'], // 202508141054357905752

  // 价格体系，是否优先使用内件数字段代替件数字段，来优先匹配价格体系命中逻辑
  calc_customer_acctrans_prefer_use_inner_qty: ['99259'], // 202509101850027174232

  calc_customer_acctrans_use_jf_w: ['98161'], // 202508141054357905752

  // 客户价格体系，是否拿算出的值和最低值做比较
  calc_customer_acctrans_compare_accmin: ['98161'], // 202508141054357905752
  // 开单记录页面底部打印运单可以选择打印模板
  print_order_template: ['98937'], // 202507251113492872813
  // 开单页不使用详细地址搜索功能，以纯文本录入
  close_order_addr_association: [], // 202508271045344908223 要求还原
  // 税金计算：按基本运费计算，不按照总运费计算
  // https://imagecdn.ymm56.com/ymmfile/static/resource/c2b445c1-fc8e-4cff-8084-708b7d17971a.jpg
  calc_acctax_only_by_acctrans: ['98890'], // 202508151149066506284
  // 切换发货人下拉选择时，联动查询对应发货人的最新品名，并更新到货物表格中品名下拉选项中
  update_product_by_change_shipper: ['99018', '90100'], // 202508061510068675403
  // 是否使用品名内件数
  weborder_use_product_inner_qty: ['99259'], // 202509101850027174232
  // 开单打印标签同时，将打印数据生成一张图保存到本地
  save_tag_img_while_print: ['97595'], // 202509211158019307413
  // 受理开单记录，grid表格列显示复制按钮
  show_copybtn_in_grid_cell: ['90100', '98259'], // 202510261412141808985
  // 新开单页面运输方式可以手动输入
  allow_input_transport_type: ['98161'], // 202511031530229238784
  // 发货人收录判断，去除收货方字段校验，只看手机号 电话
  shoulu_fahuo_ignore_consine: ['71995'],
  shoulu_addfh_okprocess: ['98508'], // 发货下拉和收录都加上 交接方式
  shoulu_addfh_backqty: ['98508'], // 发货下拉和收录都加上 回单要求
  // 计算器计算的体积长宽高，回填到规格中
  set_volume_guige_by_jisuanqi: ['82635', '88378'], // 202512020913015438452
  // 开单货物表格默认不开启键盘支持上下左右切换，可能和现有功能冲突，现在有客户要定制放开，在此处定制
  kd_use_keyup_to_jump: ['99800'], // 202511241445397776476

  // 目前系统的开单新增、编辑页面，是不支持权限组中的费用隐藏逻辑的，本次先定制支持改单场景时进入改单页，将权限组中勾选的费用相关字段改成不显示和不可编辑
  // 定制逻辑：勾选了隐藏：提付、现付、回单、月结联动运费的时候，将基本运费和总运费隐藏
  // 其他费用相关： 送货费、接货费、单价信息（accsend、 accfetch、 qtyprice、vprice、wprice）
  hide_acc_by_role_group: ['90100', '84092'], // 202512041600545505605
  // 是否算使用用来计费的单价， 新增字段 计费单价 singleprice_c
  open_singleprice_c: ['82635', '83514'], // 202512091018276635381
  // 关闭开单页收货人收发货单位下拉选择项框
  kd_hide_customer_select_box: ['84321'], // 202512101044144538013  202512101051132173259
  // 清空送货费，当切换到自提时，清空送货费
  clear_accsend_self_pickup: ['99128'], // 202508181310107435279
  // 扫码签收定位拦截半径
  scan_sign_location_radius: ['78522'], // 202601141449240405079
  // 开单去除接货车号特殊字符限制
  kd_remove_truck_number_special_char: ['98838'], // 202601171443576232559
  //开单页 不填充下一输入框的金额
  kd_no_fill_next_input: ['84769','83964','90100'], // 202601171443576232559
}
